import { render } from "./AlPizza.vue?vue&type=template&id=384c9477&scoped=true"
import script from "./AlPizza.vue?vue&type=script&lang=js"
export * from "./AlPizza.vue?vue&type=script&lang=js"

import "./AlPizza.vue?vue&type=style&index=0&id=384c9477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384c9477"]])

export default __exports__